import { render } from "./ImageGeneration.vue?vue&type=template&id=27ff2e20"
import script from "./ImageGeneration.vue?vue&type=script&lang=js"
export * from "./ImageGeneration.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__